import { ChangeDetectionStrategy, Component } from '@angular/core';

import { IconComponent } from '@shared/components/icon/icon.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  selector: 'aux-quick-forecast-cost-category-info-block',
  template: `
    <div class="flex items-center space-x-1">
      <aux-icon name="InfoCircle" [size]="16" />
      <p class="text-aux-gray-lightest">
        Selections apply only to cost categories available for each vendor contract.
      </p>
    </div>
  `,
})
export class QuickForecastCostCategoryInfoBlockComponent {}
